import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BsWallet2, BsX } from "react-icons/bs";
import CustomButton from "../custom-button/CustomButton";

type Props = {
  show: boolean;
  onHide: () => void;
};

export default function ConfirmSignature({ show, onHide }: Props) {
  const { t } = useTranslation(["components", "common"]);
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Body className="text-center d-flex flex-column align-items-center p-5">
        <h2 className="primary-modal-title modal-success-title mb-4">
          {t("wallet.modal_heading", { ns: "components" })}
        </h2>
        <div className="mb-4">
          <BsWallet2
            className="text-success"
            style={{ height: "48px", width: "48px" }}
          />
        </div>
        <p className="mb-4 fw-normal fs-16 text-dark">
          {t("wallet.confirm_nonce", { ns: "components" })}
        </p>
        <div className="d-flex justify-content-center align-items-center">
          <CustomButton className="btn btn-outline-danger btn-lg rounded-pill d-flex align-items-center">
            <BsX className="me-1" style={{ height: "24px", width: "24px" }} />
            {t("button.cancel", { ns: "common" })}
          </CustomButton>
        </div>
      </Modal.Body>
    </Modal>
  );
}
